import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useLaboratoryCreate } from '@/module/Laboratory/model/LaboratoryQuery';
import {
  LaboratorySchema,
  defaultLaboratoryValues,
  laboratorySchema,
} from '@/module/Laboratory/model/LaboratorySchema';

import { useAppNotification } from '@feature/utils';

import { LaboratoryForm } from './LaboratoryForm';

export interface LaboratoryCreateProps {
  researchCenterId: string;
}

export function LaboratoryCreate({ researchCenterId }: LaboratoryCreateProps) {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useLaboratoryCreate();

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: LaboratorySchema) => {
    mutate(
      { ...values, researchCenter: { id: Number(researchCenterId) } },
      {
        onError: notification.error,
        onSuccess: newLaboratory => {
          notification.success();
          navigate({
            to: '/research-center/$researchCenterId/lab/$labId',
            params: { labId: String(newLaboratory.id), researchCenterId: researchCenterId },
          });
        },
      },
    );
  };

  return (
    <LaboratoryForm
      title={t('laboratories.form.title.create')}
      schema={laboratorySchema}
      defaultValues={defaultLaboratoryValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
